import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@folio/components';
import type { EmailAccountDto } from 'korint-sdk';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function DisconnectAccountDialog({
  account,
  onOpenChange,
  onConfirm,
  isDeleting,
}: {
  account: EmailAccountDto | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting: boolean;
}) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={account !== null} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('connectedEmailAccounts.delete.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('connectedEmailAccounts.delete.description', {
              email: account?.primaryEmailAddress,
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>
            {t('connectedEmailAccounts.delete.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={e => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isDeleting}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 size-4 animate-spin" />
                {t('connectedEmailAccounts.delete.deleting')}
              </>
            ) : (
              t('connectedEmailAccounts.delete.confirm')
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
